<template>
  <div class="card bg-light">
    <div class="card-header">
      Advanced Search
      <span class="float-end sticky-top" style="cursor: pointer" @click="close()">
        <font-awesome-icon icon="xmark" />
      </span>
    </div>
    <div class="card-body">
      <smart-select-key-value
        id="modelSchemeId"
        v-model="model.schemeId"
        label="Scheme"
        :is-required="false"
        :options="schemeIds"
      />

      <smart-input
        id="modelSchemeReference"
        v-model="model.schemeReference"
        label="Your Scheme Reference"
        :is-required="false"
      />
      <smart-input
        id="modelRegisteredCompanyName"
        v-model="model.registeredCompanyName"
        label="Registered Company Name"
        :is-required="false"
      />
      <smart-select-text-value-numeric
        id="modelStatus"
        v-model="model.status"
        label="Status"
        :options="schemeBusinessStatuses"
        :is-required="false"
      />
      <smart-input id="modelTMLN" v-model="model.tmln" label="TMLN" :is-required="false" />
      <smart-input
        id="modelAddress1"
        v-model="model.address1"
        label="Address Line 1"
        :is-required="false"
      />
      <smart-input
        id="modelPostCode"
        v-model="model.postCode"
        label="Postcode"
        :is-required="false"
      />
      <div class="row">
        <div class="col-6">
          <smart-button
            class-override="btn-outline-secondary"
            :disabled="false"
            :loading="false"
            :click="reset"
            >Reset
          </smart-button>
        </div>
        <div class="col-6">
          <smart-submit
            :small="true"
            :disabled="false"
            :loading="loading"
            :click="newAdvancedSearch"
            label="Apply"
          />
        </div>
      </div>
    </div>
  </div>
  <confirm-dialog ref="confirm"></confirm-dialog>
</template>

<script>
import {
  SmartInput,
  SmartSubmit,
  SmartButton,
  SmartSelectTextValueNumeric,
  SmartSelectKeyValue,
  ConfirmDialog,
} from '@trustmark-2005-ltd/trustmark-shared-components';

export default {
  name: 'SchemeBusinessVerificationSearchAdvanced',
  components: {
    SmartButton,
    SmartSubmit,
    SmartInput,
    SmartSelectTextValueNumeric,
    SmartSelectKeyValue,
    ConfirmDialog,
  },
  emits: ['reset-requested', 'error-message-changed', 'close'],
  data() {
    return {
      loading: false,
      model: {
        schemeId: null,
        schemeIds: [],
        schemeReference: null,
        registeredCompanyName: null,
        status: null,
        tmln: null,
        address1: null,
        postCode: null,
      },
    };
  },
  computed: {
    schemeIdFilter() {
      return this.$route.query.schemeId;
    },
    pageNumber() {
      return this.$store.state.schemeBusiness.businessVerificationPageNumber;
    },
    schemeBusinessStatuses() {
      const values = this.$store.state.auth.appData.schemeBusinessStatuses.map((x) => {
        return { text: x.description, value: x.status };
      });
      values.splice(0, 0, { text: '(All)', value: '' });
      return values;
    },
    lastBusinessVerificationSearchConfig() {
      return this.$store.state.schemeBusiness.lastBusinessVerificationSearchConfig;
    },
    isAdvancedSearch() {
      return this.lastBusinessVerificationSearchConfig.type === 'advanced';
    },

    schemeIds() {
      const activeSchemeIds = [
        ...new Set(
          this.$store.state.schemeBusiness.businessVerificationSearchResult.results.map(
            (scheme) => scheme.schemeId,
          ),
        ),
      ];
      const opts = this.$store.state.auth.appData.schemes
        .filter((sc) => activeSchemeIds.includes(sc.schemeId))
        .map((s) => {
          return { key: s.schemeId, value: s.schemeName };
        });
      opts.unshift({ key: null, value: '' });
      return opts;
    },
  },
  watch: {
    pageNumber() {
      if (this.isAdvancedSearch) {
        this.advancedSearch();
      }
    },
  },
  methods: {
    newAdvancedSearch() {
      this.advancedSearch();
      this.$store.commit('schemeBusiness/setBusinessVerificationPageNumber', 0, { root: true });
    },
    advancedSearch() {
      this.$emit('error-message-changed', null);
      this.loading = true;

      const payload = JSON.parse(JSON.stringify(this.model));
      if (payload.schemeId) {
        payload.schemeIds.push(payload.schemeId);
      }

      payload.pageParameters = {
        size: 10,
        number: this.pageNumber,
      };

      payload.sort = {
        item: 'registeredCompanyName',
        direction: 'ascending',
      };

      this.$store
        .dispatch('schemeBusiness/verificationSearchAdvanced', payload)
        .then(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$emit('error-message-changed', err.message);
        });
    },
    reset() {
      this.model.status = null;
      this.model.schemeId = null;
      this.model.schemeReference = null;
      this.model.registeredCompanyName = null;
      this.model.tmln = null;
      this.model.address1 = null;
      this.model.postCode = null;
      this.$emit('reset-requested', null);
    },
    close() {
      this.$emit('close', null);
    },
  },
};
</script>
